import {useEffect} from 'react';
import useTestableRef from '../../hooks/useTestableRef';
import DomUtils from '../../v2/utils/DomUtils';
import Track from '../../v2/utils/tracking';

const useNewpayWalletLoader = (getNewpayDetails, setNewpayScriptFailure, isNewpayAvailable) => {
  const loadedScriptRef = useTestableRef(null);
  const NEWPAY_SCRIPT = 'https://assets.dekopay.com/wallet/index.js';
  
  useEffect(() => {
    if (isNewpayAvailable) {
      const loadScript = () => {
        DomUtils.addScript(NEWPAY_SCRIPT)
          .then(() => getNewpayDetails())
          .then(() => {
            loadedScriptRef.current = true;
          })
          .catch((err) => {
            setNewpayScriptFailure();
            Track.track(`Error loading newpay script ${err}`);
          });
      };
  
      if (!loadedScriptRef.current) {
        loadScript();
      }
    }
  }, []);

  return null;
};

export default useNewpayWalletLoader;
